import { render, staticRenderFns } from "./step-auth.vue?vue&type=template&id=4ec64750&"
import script from "./step-auth.vue?vue&type=script&lang=js&"
export * from "./step-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports